import { render, staticRenderFns } from "./broker_approve.vue?vue&type=template&id=7f8350f2"
import script from "./broker_approve.vue?vue&type=script&lang=js"
export * from "./broker_approve.vue?vue&type=script&lang=js"
import style0 from "./broker_approve.vue?vue&type=style&index=0&id=7f8350f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports